/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-restricted-imports  */
/* eslint-disable sonarjs/no-duplicate-string */
import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AppstateFacade,
  SearchClientRequest,
  AlertInfo,
  AlertDismissRequest,
  NavigationResponse,
  Clients,
  Entitlement,
} from '@cigna/cigna-for-brokers/shell/data-access';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  MatAlertDialogComponent,
  IdleDialogComponent,
} from '@cigna/cigna-for-brokers/shared/ui';
import { Menu } from '@cigna/cigna-for-brokers/shared/util';
import { Subject, Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import uuid from 'uuid';
import { ActivatedRoute, Router, NavigationEnd, Event } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { WindowService } from '@cigna/shared/angular/core/window-util';
import { DOCUMENT } from '@angular/common';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { takeUntil } from 'rxjs/operators';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppFacade } from '@cigna/cigna-for-brokers/shared/data-access';
import includes from 'lodash/includes';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LoginFacade } from '@cigna/cigna-for-brokers/login-data-access';
import { TranslateService } from '@ngx-translate/core';
import {
  GatewayConfig,
  GATEWAY_CONFIG,
  AppStateGateway,
} from '@cigna/cigna-for-brokers/shared/gateways';
import { get } from 'lodash';

@Component({
  selector: 'cigna-layout-secure',
  templateUrl: './layout-secure.component.html',
  styleUrls: ['./layout-secure.component.scss'],
})
export class LayoutSecureComponent implements OnInit, OnDestroy {
  urlPath = window.location.origin;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  sideBarToggleFlag: boolean;
  canHideSideNav = false;
  alerts$ = this.appstateFacade.alerts$;
  navigation$ = this.appstateFacade.navigation$;
  firstName$ = this.appstateFacade.firstName$;
  lastName$ = this.appstateFacade.lastName$;
  userType$ = this.appstateFacade.userType$;
  loading$ = this.appstateFacade.loading$;
  resizeSideNavToggle$ = this.appstateFacade.resizeSideNavToggle$;
  appRedirect$ = this.appstateFacade.appRedirect$;
  menuItemsWithSubMenu$ = this.appstateFacade.menuItemsWithSubMenu$;
  navigationEntitlements$ = this.appstateFacade.navigationEntitlements$;
  currentYear: string = new Date().getFullYear().toString();
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  profileData$ = this.appstateFacade.isProfileUser$;

  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  isOktaLoginEnabled: boolean;
  public isScreenSmall: boolean;
  alertStatus: string;
  operatorId: unknown;
  isAllInitialCallsDone = false;
  navigationDetails: NavigationResponse;
  isDarkTheme = false;
  dir = 'ltr';
  alertStatusCookieName = 'alert-status';
  currentUrlPath = '';
  routerEvent$;
  isImpersonatorFlag = false;
  hasIfpAdminMenu = false;
  envName: string;

  idleModalObj: {
    title: string;
    idleState: string;
    timedOut: boolean;
    isTimeOut: boolean;
    isIdealStarted: boolean;
    isImpersonator?: boolean;
  };

  idleModalRef?: MatDialogRef<IdleDialogComponent>;
  internalFirstName: string;
  internalLastName: string;
  @ViewChild(MatSidenav) sidenav: MatSidenav;
  dialogSubscription?: Subscription;

  hasCommercialCompensationStatements$ =
    this.appstateFacade.hasOneOfEntitlements$([
      Entitlement.CommercialCompensationStatements,
      Entitlement.SgpCompensationTitle,
    ]);
  agencyResponse$ = this._appFacade.agencyResponse$;
  isSiteDown: boolean;
  isDivestEnabled: boolean;

  constructor(
    private appstateFacade: AppstateFacade,
    private router: Router,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    public _window: WindowService,
    public idle: Idle,
    public dialog: MatDialog,
    private _gw: AppStateGateway,
    private featureTogglesFacade: FeatureTogglesFacade,
    public _appFacade: AppFacade,
    public _loginFacade: LoginFacade,
    private translate: TranslateService,
    @Inject(GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {
    this.routerEvent$ = router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrlPath = event?.url;
        this.setSideNavDisplay();
      }
    });

    this.appstateFacade.getTools();
  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
  }

  toggleDir() {
    // eslint-disable-next-line eqeqeq
    this.dir = this.dir == 'ltr' ? 'rtl' : 'ltr';
  }
  processLogout(): void {
    if (this.isOktaLoginEnabled) {
      this._loginFacade.logout('logout');
    } else {
      this.appstateFacade.logOut({ variation: 'logout', linkName: 'logout' });
    }
  }

  processImpersonatorLogout() {
    if (this.isOktaLoginEnabled) {
      this._loginFacade.impersonatorLogout();
    } else {
      this.appstateFacade.impersonatorLogOut(false);
    }
  }

  navigateSecureMessage(data: { url: string; target: string }) {
    this.appstateFacade.windowOpen(data);
  }

  resizeSideNavToggle(data: { open: boolean }) {
    this.appstateFacade.resizeSideNavToggle(data);
  }
  appRedirect(data: { redirect: string }) {
    this.appstateFacade.appRedirect(data);
  }

  ngOnInit() {
    // get flag from resource bundle

    this.envName = this._config.environmentName;
    const featureFlagBase = this.translate.instant(`featureFlag`);

    const flagObj = get(featureFlagBase, this.envName);
    this.isDivestEnabled = get(flagObj, 'isDivestEnabled');

    // const siteDown = this.translate.instant(`global.isSiteDown`);
    // this.isSiteDown = siteDown === 'true';
    // if (this.isSiteDown) {
    //   return;
    // }

    if (
      // eslint-disable-next-line sonarjs/no-duplicate-string
      window.location.href.includes('/secure/home') ||
      window.location.href.includes('/secure/commercial')
    ) {
      this.cookieService.set('is-broker', 'true', {
        path: '/',
      });
    }

    this.internalFirstName = this.cookieService.get('fname');
    this.internalLastName = this.cookieService.get('lname');

    this.appstateFacade.updateUserType(false);

    /* const navData = this.route.snapshot.data.navData;
    if (navData?.data) {
      this.appstateFacade.setBrNavigationSuccess(navData);
    } else {
      this.openNoActiveCls();
    }
  */

    this.navigation$.subscribe((nav: NavigationResponse) => {
      localStorage.removeItem('iv-user');
      if (nav) {
        localStorage.setItem('iv-user', nav.ssoId);
        this.navigationDetails = nav;
      } else {
        // this.openNoActiveCls();
      }
    });

    this.isOktaLoginEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOktaLoginEnabled) => {
        this.isOktaLoginEnabled = isOktaLoginEnabled;
      });

    this.profileData$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((res) => {
      if (res) {
        this.operatorId = res.accessTokenBody['agent.operatorId'];
      }
      if (this.operatorId && this.operatorId !== '') {
        this.isImpersonatorFlag = true;
      }
    });

    this.agencyResponse$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: any) => {
        if (
          res.agencies.length === 0 ||
          res.show_affirmation_popup === 'False'
        ) {
          this.appstateFacade.setLegalAffirmStatus(false);
        } else if (res.show_affirmation_popup === 'True') {
          this.appstateFacade.setLegalAffirmStatus(true);
        }
      });

    this.hasCommercialCompensationStatements$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((hasCompensationTile) => {
        if (hasCompensationTile) {
          this._appFacade.getAgencyList();
        }
      });

    /* istanbul ignore next */
    if (includes(this.urlPath, 'ifpadmin')) {
      this.hasIfpAdminMenu = true;
    }

    if (!this.hasIfpAdminMenu) {
      this.idleModalObj = {
        idleState: 'Not started.',
        timedOut: false,
        isIdealStarted: false,
        isTimeOut: false,
        title: 'Idle Modal',
      };
      /* sets an idle timeout of 10 minutes*/
      this.idle.setIdle(+this._gw.getTimeoutDuration());

      /* sets a timeout period of 5 minutes. after 10 minutes of inactivity, the user will be considered timed out. */
      this.idle.setTimeout(+this._gw.getLogoutDuration());

      this.idle.onTimeout.subscribe(() => {
        this.idleModalObj.title = 'Log out';
        this.idleModalObj.idleState = 'Timed out!';
        this.idleModalObj.timedOut = true;
        this.idleModalObj.isTimeOut = true;
        this.idleModalObj.isIdealStarted = true;
        this.idleModalObj.isImpersonator = this.isImpersonatorFlag;
        this.idleModalObj.idleState =
          'Due to inactivity, your session automatically logged out.';
        sessionStorage.setItem('isLoggedOut', 'true');
      });
      this.idle.onIdleStart.subscribe(() => {
        this.idleModalObj.title = 'Idle Modal';
        this.idleModalObj.isIdealStarted = true;
        this.idleModalObj.isTimeOut = false;
        this.idleModalObj.idleState = "You've gone idle!";
        this.idleModalObj.isImpersonator = this.isImpersonatorFlag;
        this.openIdleDialog();
        this.idle.clearInterrupts();
      });
      this.idle.onTimeoutWarning.subscribe((countdown: string) => {
        this.idleModalObj.title = 'About to Log out';
        this.idleModalObj.isImpersonator = this.isImpersonatorFlag;
        this.idleModalObj.idleState = `Your session is about to expire in ${this.toHHMMSS(
          countdown,
        )} minutes.`;
      });
      this.reset();
    }
  }

  setSideNavDisplay() {
    if (window.location.href.includes('/secure/home/login-success-dialog')) {
      this.canHideSideNav = true;
    } else {
      this.canHideSideNav = false;
    }
  }

  openNoActiveCls(): void {
    this.dialog.open(MatAlertDialogComponent, {
      autoFocus: false,
      disableClose: true,
      minWidth: '700px',
      data: {
        heading: 'global.err',
        message: 'global.noActiveClient',
        buttonText: 'global.ok',
      },
    });
  }

  openExternalLink(from: any) {
    if (from.source === 'CignaExpress') {
      this.appstateFacade.windowOpen({
        url: 'professional/cignaexpress',
        target: '_blank',
      });
    }
  }

  openIdleDialog() {
    if (this.idleModalRef) {
      this.idleModalRef.close();
    }
    this.idleModalRef = this.dialog.open(IdleDialogComponent, {
      width: '50rem',
      position: {
        left: '20%',
      },
      data: this.idleModalObj,
      disableClose: true,
      hasBackdrop: true,
    });
    this.dialogSubscription = this.idleModalRef
      .afterClosed()
      .subscribe((res) => {
        if (res === 'DATA_RESET') {
          this.dataReset();
        } else if (res === 'LOGOUT') {
          this.processLogout();
        } else if (res === 'LOGOUT_COMPLETED') {
          this.processLogoutRedirect();
        } else if (res === 'IMPERSONATOR_LOGOUT') {
          this.processImpersonatorLogout();
        }
      });
  }

  processLogoutRedirect() {
    let urlLogout = '/web/logout';
    if (location.hostname === 'localhost') {
      urlLogout = 'https://int2.cignaforbrokers.com/public/login';
    }
    window.location.href = urlLogout;
  }

  dataReset() {
    sessionStorage.setItem('isLoggedOut', 'false');
    this._loginFacade.staySignIn();
    this._appFacade.dispatchKeepAlive();

    this.reset();
  }

  reset() {
    if (this.idleModalRef) {
      this.idleModalRef.close();
    }
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.setIdle(+this._gw.getTimeoutDuration());
    this.idle.watch();
    this.idleModalObj.idleState = 'Started.';
    this.idleModalObj.timedOut = false;
  }

  toHHMMSS(secs: string) {
    const secNum = parseInt(secs, 10);
    return [
      Math.floor(secNum / 3600) % 24,
      Math.floor(secNum / 60) % 60,
      secNum % 60,
    ]
      .map((v) => (v < 10 ? `0${v}` : v))
      .filter((v, i) => v !== '00' || i > 0)
      .join(':');
  }

  isFundingSolution(currentUrlPath: string) {
    return currentUrlPath === '/secure/commercial/funding';
  }

  isContactUsIntuitive(currentUrlPath: string) {
    return includes(currentUrlPath, '/secure/contact-us');
  }

  isSolutionsInsights(currentURLPath: string) {
    return currentURLPath === '/secure/commercial/solutions-insights';
  }

  enableFsWrapper(currentUrlPath: string) {
    return this.isFundingSolution(currentUrlPath);
  }

  enableFullScreen(currentPath: string) {
    return this.isContactUsIntuitive(currentPath);
  }
  ngOnDestroy() {
    this.dialogSubscription?.unsubscribe();
    this.routerEvent$?.unsubscribe();
  }
}
